export class LineResult {
    Name: string;
    Label: string;
    Type: string;
    noligne: number;
    ListOrder: any[];
    NumOrder: number;
    TypeOrder: number;
    ThumbInfo: boolean;

    public Clear() {
        this.Name = '';
        this.Label = '';
        this.Type = '';
        this.noligne = 0;
        this.ListOrder = [];
        this.NumOrder = -1;
        this.TypeOrder = 0;
        this.ThumbInfo = false;
    }
}
